import React from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  Divider,
  useTheme
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import MKTypography from "../MKTypography";
import { PRIMARY_PINK, TRANSPARENT_BLACK_08 } from "../../constants";

function Footer() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 4,
        backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : '#f8f9fa',
        borderTop: `1px solid ${theme.palette.mode === 'dark' ? '#404040' : '#e0e0e0'}`
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'center', md: 'flex-start' }, gap: 3 }}>
          {/* Company Info */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <MKTypography
              variant="h6"
              fontWeight="bold"
              mb={1}
              sx={{ color: PRIMARY_PINK }}
            >
              San Diego Gaming
            </MKTypography>
            <MKTypography variant="body2" color="text.secondary" mb={1}>
              Connecting San Diego's gaming community
            </MKTypography>
            
          </Box>

          {/* Quick Links */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <MKTypography
              variant="subtitle1"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Quick Links
            </MKTypography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/clubs"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: PRIMARY_PINK,
                    textDecoration: 'underline'
                  }
                }}
              >
                Browse Clubs
              </Link>
              <Link
                component={RouterLink}
                to="/create-club"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: PRIMARY_PINK,
                    textDecoration: 'underline'
                  }
                }}
              >
                Create Club
              </Link>
              <Link
                component={RouterLink}
                to="/merch"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: PRIMARY_PINK,
                    textDecoration: 'underline'
                  }
                }}
              >
                Merchandise
              </Link>
              <Link
                component={RouterLink}
                to="/sponsor"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: PRIMARY_PINK,
                    textDecoration: 'underline'
                  }
                }}
              >
                Sponsor
              </Link>
            </Box>
          </Box>

          {/* Legal Links */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <MKTypography
              variant="subtitle1"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Legal
            </MKTypography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/privacy-policy"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: PRIMARY_PINK,
                    textDecoration: 'underline'
                  }
                }}
              >
                Privacy Policy
              </Link>
              <Link
                component={RouterLink}
                to="/terms-of-service"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: PRIMARY_PINK,
                    textDecoration: 'underline'
                  }
                }}
              >
                Terms of Service
              </Link>
              <Link
                component={RouterLink}
                to="/accessibility"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': {
                    color: PRIMARY_PINK,
                    textDecoration: 'underline'
                  }
                }}
              >
                Accessibility
              </Link>
            </Box>
          </Box>

          {/* Contact Info */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <MKTypography
              variant="subtitle1"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Contact
            </MKTypography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                             <MKTypography variant="body2" color="text.secondary">
                 Email: info@sandiegogaming.com
               </MKTypography>
               <MKTypography variant="body2" color="text.secondary">
                 Privacy: privacy@sandiegogaming.com
               </MKTypography>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Copyright */}
        <Box sx={{ textAlign: 'center' }}>
          <MKTypography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} San Diego Gaming. All rights reserved.
          </MKTypography>
          <MKTypography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This website is committed to accessibility and complies with ADA standards.
          </MKTypography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
